// app-pages/ContactUs/NewsletterForm.tsx
"use client";
import { useState } from "react";
import { Flex, Input, Button, Text } from "@chakra-ui/react";

export default function NewsletterForm() {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [newsletterSuccess, setNewsletterSuccess] = useState(false);
  const [newsletterError, setNewsletterError] = useState(false);

  const handleNewsletterChange = (e: any) => {
    setNewsletterEmail(e.target.value);
  };

  const handleNewsletterSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNewsletterError(false);
    setNewsletterSuccess(false);

    try {
      const response = await fetch("https://api.deepmode.ai/users/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: newsletterEmail }),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      const responseData = await response.json();
      console.log(responseData);
      setNewsletterSuccess(true);
    } catch (error) {
      setNewsletterError(true);
      console.error("There was a problem with the fetch operation:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Flex as="form" onSubmit={handleNewsletterSubmit} direction="column" align="center" w="100%">
        <Input
          mt="20px"
          maxW={{ base: "100%", md: "455px" }}
          bg="#1A1D21"
          border="1px solid #363A3D"
          placeholder="Email"
          name="newsletterEmail"
          type="email"
          value={newsletterEmail}
          onChange={handleNewsletterChange}
          mb="8px"
        />
        <Button
          type="submit"
          mt="10px"
          w={{ base: "100%", md: "455px" }}
          bg="button.500"
          color="white"
          isLoading={loading}
          _hover={{ opacity: 0.9 }}
        >
          Join Newsletter
        </Button>
      </Flex>
      {newsletterSuccess && (
        <Text color="green.500" mt="4">
          Subscribed successfully!
        </Text>
      )}
      {newsletterError && (
        <Text color="red.500" mt="4">
          Failed to subscribe. Please try again.
        </Text>
      )}
    </>
  );
}
